























import { Component, Vue } from 'vue-property-decorator';
import { NewRequestButton, UserMenu } from './AppHeaderParts';

@Component({
  components: {
    NewRequestButton,
    UserMenu,
  },
})
export default class AppHeader extends Vue {
  get currentView() {
    return this.$route.name;
  }

  get globalLoading() {
    return this.$store.getters.globalLoading;
  }
}
